import { DimensionInfo, ChartDataResponse } from "@api/common";

export function filterDimensionsByData(dimensions: DimensionInfo[], data: ChartDataResponse): DimensionInfo[] {
    const result = dimensions.filter(d =>
        data.metrics.some(m => m.data.some(i => i["dimension-values"].indexOf(d.dimension) !== -1))
    );

    return result.length === 0 ? dimensions : result;
}
